@if (!data) {
  <p>{{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.NOT_PROVIDED' | translate }}</p>
}

<h2 mat-dialog-title>
  {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.TITLE' | translate }}
</h2>

<mat-dialog-content [class.compact-warning]="typeChangeBlocked || awaitingTypeChangeConfirmation">
  @if (typeChangeBlocked) {
    <glxy-alert type="error" [size]="'small'">
      {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.TYPE_CHANGE_BLOCKED' | translate }}
    </glxy-alert>
  } @else if (awaitingTypeChangeConfirmation) {
    <glxy-alert type="warning" [size]="'small'">
      {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.TYPE_CHANGE_WARNING' | translate }}
    </glxy-alert>
  } @else {
    <p>
      {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.HEADER' | translate }}
    </p>

    <form [formGroup]="senderForm" (keyup.enter)="submitForm()">
      <div class="domain">
        <glxy-form-field prefixText="example@">
          <glxy-label>{{ 'COMMON.DOMAIN' | translate }}</glxy-label>
          <input type="text" placeholder="example.com" matInput formControlName="senderDomain" autocomplete="off" />
        </glxy-form-field>
      </div>

      @if (enableDomainTypeSelection) {
        <div class="domain-type-selection">
          <mat-checkbox formControlName="shareWithOtherBusiness">
            {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.SHARE_WITH_OTHER_BUSINESS' | translate }}
          </mat-checkbox>
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions [class.compact-warning]="typeChangeBlocked || awaitingTypeChangeConfirmation">
  @if (typeChangeBlocked) {
    <button mat-stroked-button type="button" (click)="goBack()">
      {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.GO_BACK' | translate }}
    </button>
  } @else if (awaitingTypeChangeConfirmation) {
    <button mat-stroked-button type="button" (click)="goBack()">
      {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.GO_BACK' | translate }}
    </button>

    <button
      mat-flat-button
      type="submit"
      color="primary"
      [disabled]="(authorizedDomain$ | glxyAsyncStatus | async).status === 'loading'"
      >
      <glxy-button-loading-indicator
        [isLoading]="(authorizedDomain$ | glxyAsyncStatus | async).status === 'loading'"
        (click)="submitForm()"
        >
        {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.CONTINUE' | translate }}
      </glxy-button-loading-indicator>
    </button>
  } @else {
    <button mat-stroked-button type="button" (click)="close()">
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>

    <button
      mat-flat-button
      type="submit"
      color="primary"
      [disabled]="!senderForm?.valid || (authorizedDomain$ | glxyAsyncStatus | async).status === 'loading'"
      >
      <glxy-button-loading-indicator
        [isLoading]="(authorizedDomain$ | glxyAsyncStatus | async).status === 'loading'"
        (click)="submitForm()"
        >
        {{ 'DOMAIN_AUTHORIZATION.NEW_DOMAIN_DIALOG.START' | translate }}
      </glxy-button-loading-indicator>
    </button>
  }
</mat-dialog-actions>
